import type { OrderRateReasonMiniEntity } from '@/features/orderRateReason/domain/entities/OrderRateReasonMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { ReviewStatus } from '../enums/ReviewStatus'

export class OrderRateMiniEntity {
  id?: string
  user?: UserMiniEntity | null
  orderReferenceCode?: string | null
  userDisplayName?: string | null
  userPhotoUrl?: string | null
  orderId?: string
  branchRate?: number
  driverRate?: number
  driverId?: number | null
  branchComment?: string | null
  driverComment?: string | null
  createdAt?: string | null
  driverFullName?: string | null
  branchName?: string | null
  orderBranchId?: number
  userOrderRateReasons?: Array<OrderRateReasonMiniEntity> | null
  reviewStatus?: ReviewStatus
}
